import type { SignalRow } from '@shared/flow/signal-view';

/**
 * A Signals row is a dialable call task when its `signal_tactic` mentions
 * "call" and is not an automated step (the same `auto` rule
 * `signal-verification.ts` uses for `live_auto`). The group-header checkbox
 * selects only these — dialing is call-tasks-only (Spencer).
 */
export function isCallTask(row: Partial<Pick<SignalRow, 'signal_tactic'>>): boolean {
  const tactic = row.signal_tactic ?? '';
  return /call/i.test(tactic) && !/auto/i.test(tactic);
}
